// @flow
import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import FamilyCollectionBanner from '@homeaway/react-family-collection-banner';
import FamilyCollectionBannerLingua from '@homeaway/react-family-collection-banner/lingua.json';

import withLingua from '../withLingua/withLingua';
import routerActions from '../../actions/router';
import {media} from '../../utils/breakpoints';

import type {LinguaProps} from '../withLingua/withLingua';
import type {State as ReduxState} from '../../reducers';

type StateProps = {
    isMobile: boolean
};

type DispatchProps = {
    addFilter: typeof routerActions.addFilter
};

type Props = StateProps & DispatchProps & LinguaProps;

/**
 * Adapter component wrapping react-family-collection-banner
 */
const FamilyCollectionBannerContainer = ({
    addFilter,
    isMobile,
    messages
}: Props) => (
    <FamilyCollectionBanner
        isMobile={isMobile}
        translations={messages}
        triggerFilter={(filterId) => addFilter(filterId)}
    />
);

const mapStateToProps = ({viewport: {breakpoint}}: ReduxState): StateProps => ({
    isMobile: !media(breakpoint, {
        minWidth: 'SM_MIN'
    })
});

const mapDispatchToProps = {
    addFilter: routerActions.addFilter
};

const ComposedFamilyCollectionBanner = compose(
    withLingua({
        namespace: (FamilyCollectionBannerLingua.namespace: string),
        category: FamilyCollectionBannerLingua.categories[0]
    }),
    connect(
        mapStateToProps,
        mapDispatchToProps
    )
)(FamilyCollectionBannerContainer);

ComposedFamilyCollectionBanner.displayName = 'FamilyCollectionBanner';
export default ComposedFamilyCollectionBanner;

export {shouldDisplayAtIndex} from '@homeaway/react-family-collection-banner';
